export default "__VITE_ASSET__55d5e7a6__"